// Synchronous registry for focusing a mounted ChatInput by contextId.
// iOS Safari requires focus() to fire within the same user-gesture call stack,
// so we avoid routing through React state and call the registered focus fn directly.

const DEFAULT_KEY = '__default__';
const registry = new Map();

const keyFor = (contextId) => contextId ?? DEFAULT_KEY;

export const registerChatInputFocus = (contextId, fn) => {
  if (typeof fn !== 'function') return () => {};
  const key = keyFor(contextId);
  let handlers = registry.get(key);
  if (!handlers) {
    handlers = new Set();
    registry.set(key, handlers);
  }
  handlers.add(fn);
  return () => {
    const existing = registry.get(key);
    if (!existing) return;
    existing.delete(fn);
    if (existing.size === 0) registry.delete(key);
  };
};

export const focusChatInput = (contextId) => {
  const invoke = (handlers) => {
    if (!handlers || handlers.size === 0) return false;
    handlers.forEach(fn => {
      try { fn(); } catch (_) { /* noop */ }
    });
    return true;
  };
  if (invoke(registry.get(keyFor(contextId)))) return true;
  return invoke(registry.get(DEFAULT_KEY));
};
